// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__Eh-u2","clinicsSelect":"TableHeading_clinicsSelect__1uHNm"};